import { GlobalAxios } from "../axios/axios-config";
import { IInternalProcClassification } from "../models/internal-proc-classification";

const INTERNAL_PROC_CLASSIFICATION_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/InternalProcClassification";

export const internalProcClassification = (params?: any) => {
  return GlobalAxios.get<IInternalProcClassification[]>(
    INTERNAL_PROC_CLASSIFICATION_ROUTE,
    {
      params,
    }
  );
};
